import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=48aba3ea&"
import script from "./Slideshow.vue?vue&type=script&lang=js&"
export * from "./Slideshow.vue?vue&type=script&lang=js&"
import style0 from "./Slideshow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports